export default __webpack_public_path__ + "static/media/myplanIconBlue.607a0f00.svg";